// extracted by mini-css-extract-plugin
export default {"radioLabelContainer":"OrganizationInfo_radioLabelContainer__1-JjM","submit":"OrganizationInfo_submit__1h7KK","center":"OrganizationInfo_center__83Mse"};